import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';

const Header = ({ setShowCreate }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 4 }}>{t('screens.esign.eyebrow')}</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('screens.esign.title')}</div>
      </div>
      <button
        onClick={() => setShowCreate(true)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '10px 20px',
          background: S.burgundy,
          border: 'none',
          borderRadius: 10,
          fontSize: 14,
          fontWeight: 600,
          color: '#fff',
          cursor: 'pointer',
        }}
      >
        <Icon name='plus' color='#fff' size={16} /> {t('screens.esign.newRequest')}
      </button>
    </header>
  );
};

export default Header;
